import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ErrorMessage = /** @class */ (function () {
    function ErrorMessage(category, // Uppercase undescore, e.g. LOGIN_ERROR
    message, // Short summary, e.g. `Http failure response for https://localhost:4200/ws/user/sign/in/google: 400 Bad Request`
    log // Long summary
    ) {
        this.category = category;
        this.message = message;
        this.log = log;
    }
    return ErrorMessage;
}());
export { ErrorMessage };
var ErrorService = /** @class */ (function () {
    function ErrorService(http) {
        this.http = http;
    }
    ErrorService.prototype.logError = function (error) {
        return this.http.post("/ws/human-error", error);
    };
    ErrorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErrorService_Factory() { return new ErrorService(i0.ɵɵinject(i1.HttpClient)); }, token: ErrorService, providedIn: "root" });
    return ErrorService;
}());
export { ErrorService };
